import { default as palette } from "@apps/patient-core/palette";

export const themeColour = palette.grape[500];
